// ignore-string-localization

import React, { ReactNode } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Banners } from '../../@mrkt/features/Banner/Banners';
import { NavBar } from './Nav/NavBar';
import { getLinkStyle } from '../ui';
import { Footer } from './Footer';
import { Main } from './Main';
import { useRouteBanners } from './useRouteBanners';
import { useLayoutContext } from './LayoutState';
import { PreviewLink } from './PreviewLink';
import { useRouter } from 'next/router';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  min-height: 100%;
  width: 100%;
  background: ${({ theme }) => theme.layout.background};
  color: ${({ theme }) => theme.layout.text};
  -webkit-font-smoothing: antialiased;
`;

type LayoutProps = {
  children: ReactNode;
};

// terrible hack to override some bootstrap *&^# for now
const UndoLegacyStyles = createGlobalStyle`
  .footer-default .nav a {
    ${props => getLinkStyle(props)}
  }
`;

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const router = useRouter();
  const { showNavBar, showFooter, isPreview } = useLayoutContext();

  useRouteBanners();

  // plain mode: shows no nav/footer to comply with apple terms of service
  // when linked from the mobile app
  const plainMode = 'plain' in (router.query || {});

  return (
    <>
      <LayoutContainer>
        {!plainMode && showNavBar && <NavBar />}
        <Banners />
        <Main>{children}</Main>
        {!plainMode && showFooter && <Footer />}
        {isPreview && process.browser && <PreviewLink />}
      </LayoutContainer>
      <UndoLegacyStyles />
    </>
  );
};
